import { configureStore } from '@reduxjs/toolkit';

import themeReducer from './slice/themeSlice';
import userReducer from './slice/userSlice';
import gameReducer from './slice/gameSlice';
import ordersReducer from './slice/orderSlice';
import balanceReducer from './slice/balanceSlice';

export const store = configureStore({
    reducer: {
        theme: themeReducer,
        user: userReducer,
        orders: ordersReducer,
        balance: balanceReducer,
        games: gameReducer
    }
}); 